import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useTransactionsStore = defineStore('transactions', () => {
    const allTransactions = ref([]);
    const meta = ref(null);

    const reset = () => {
        allTransactions.value = [];
        meta.value = null;
    };

    const actions = {
        searchTransactions: (params) => axios.post('/api/v1/transactions/search', params),
    };

    return {
        allTransactions,
        meta,
        reset,
        ...actions,
    };
});
